import { render, staticRenderFns } from "./cancelBuddy.vue?vue&type=template&id=d2e928c2&"
import script from "./cancelBuddy.vue?vue&type=script&lang=js&"
export * from "./cancelBuddy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports